import i18n from '@/i18n';
import { goToCart, goToCheckout } from '@/utils/Common/Redirects';
import EVENTS from '@/utils/Constants/Events';
import LINK from '@/utils/Constants/Link';
import SmarteditController from '@/utils/Controllers/SmarteditController';
import PropTypes from 'prop-types';
import React, { Suspense, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider, useTranslation } from 'react-i18next';

// import components
import ButtonCartBraun from '@/components/atoms/ButtonCartBraun';
import MiniCartCTA from '@/components/molecules/MiniCart/MiniCartCTA';
import MiniCartEmpty from '@/components/molecules/MiniCart/MiniCartEmpty';
import MiniCartFooter from '@/components/molecules/MiniCart/MiniCartFooter';
import MiniCartNotEmpty from '@/components/molecules/MiniCart/MiniCartNotEmpty';

const MINICART_COUNTER_ID = 'js-nav-mobile-cart-counter';

const MiniCartDrawerBraun = () => {
  const [miniCart, setMiniCart] = useState();
  const { t } = useTranslation();

  useEffect(() => {
    DLG.EVE.on(EVENTS.CART.REFRESH, setMiniCart);

    return () => {
      DLG.EVE.off(EVENTS.CART.REFRESH, setMiniCart);
    };
  }, []);

  if (!miniCart) return null;

  const isMiniCartEmpty = !miniCart.entries
    ? true
    : miniCart.entries.length <= 0;

  const miniCartClass = `bra-miniCart dln-miniCart${
    isMiniCartEmpty ? ' dln-miniCart--empty' : ''
  }`;

  return (
    <div className={miniCartClass}>
      <div className='bra-miniCart__arrow dln-miniCart__arrow' />
      <div className='dln-miniCart__wrapper'>
        <div className='dln-miniCart__head'>
          <span
            className='dln-miniCart__mainTitle'
            dangerouslySetInnerHTML={{
              __html: t('cart:cart.miniCart.title', {
                items: isMiniCartEmpty ? '0' : miniCart.entries.length,
              }),
            }}
          />
        </div>
        {!isMiniCartEmpty ? (
          <>
            <MiniCartNotEmpty cart={miniCart} />
            <MiniCartFooter
              totalPrice={miniCart.totalPrice}
              deliveryMode={miniCart.deliveryMode}
            />
            <MiniCartCTA goToCart={goToCart} goToCheckout={goToCheckout} />
          </>
        ) : (
          <MiniCartEmpty />
        )}
      </div>
    </div>
  );
};

const MiniCartBraun = ({ glyph, modifiers }) => {
  const [counter, setCounter] = useState(null);
  const [drawerIsVisible, setDrawerIsVisible] = useState(false);

  const loadAddDrawer = () => {
    setDrawerIsVisible(true);
  };

  const loadRemoveDrawer = () => {
    setDrawerIsVisible(false);
  };

  const updateCounterUI = count => {
    setCounter(count);
    const el = document.getElementById(MINICART_COUNTER_ID);
    if (el) {
      el.style.display = count >= 1 ? 'block' : 'none';
      el.innerHTML = count;
    }
  };

  const loadManageDrawer = e => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      e.stopPropagation();
      setDrawerIsVisible(true);
    } else if (e.key === 'ArrowUp' || e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      setDrawerIsVisible(false);
    } else if (e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      setDrawerIsVisible(!drawerIsVisible);
    }
  };

  useEffect(() => {
    DLG.EVE.on(EVENTS.BALOON.UPDATE.CART, updateCounterUI);
    DLG.EVE.emit(EVENTS.CART.GET);
  }, []);
  return (
    <ButtonCartBraun
      modifiers={modifiers.split(' ')}
      glyph={glyph}
      counter={counter}
      linkUrl={LINK.CART}
      onMouseEnter={loadAddDrawer}
      onMouseLeave={loadRemoveDrawer}
      onKeyDown={loadManageDrawer}
      drawerKeyDown={e => {
        if (e.key === 'Escape') {
          e.preventDefault();
          e.stopPropagation();
          loadRemoveDrawer();
        }
      }}
      drawerIsVisible={drawerIsVisible}
      Drawer={MiniCartDrawerBraun}
    />
  );
};

MiniCartBraun.propTypes = {
  glyph: PropTypes.string,
  modifiers: PropTypes.string,
};

MiniCartBraun.defaultProps = {
  glyph: null,
  modifiers: '',
};

const PortalComponent = () => {
  const el = document.getElementById('js-r-entry-braun-minicart');
  if (el && !el.hasChildNodes()) {
    i18n.loadNamespaces(['cart']);
    return ReactDOM.createPortal(
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<div />}>
          <MiniCartBraun {...el.dataset} />
        </Suspense>
      </I18nextProvider>,
      el,
    );
  }
  return null;
};

export const renderCartIconPortal = () => {
  const entries = SmarteditController.getEditorialEntries(
    '#js-braun-header-cart-portal',
  );
  if (entries[0]) {
    ReactDOM.render(<PortalComponent />, entries[0]);
  }
};

export default PortalComponent;
